export default "__VITE_ASSET__DhFUNeAk__"